import type { ReactNode } from 'react';
import { FileText } from 'lucide-react';
import { TableCell } from '@/components/ui/table';

export function CarryDocumentTitleCell({ children }: { children: ReactNode }) {
  return (
    <TableCell>
      <div className="flex items-center gap-3">
        <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-sm bg-muted">
          <FileText className="h-4 w-4 text-muted-foreground" />
        </div>
        {children}
      </div>
    </TableCell>
  );
}
